import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { GET_GL_MASTER_DATA } from "./apiRoutes";

const mutateUpdateGlMasterData = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${GET_GL_MASTER_DATA}/${id}`, data);
};

const useUpdateGlMasterDataMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateGlMasterData,
    ...queryParams,
  });

export default useUpdateGlMasterDataMutation;
